import './corporateconcierge/style';
import FormStructure from './corporateconcierge/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js